import React from "react";
import styles from "./Portfolio.module.scss";
import Project from "./Project/Project";
const Portfolio = () => {
  return (
    <section id="projects" className={styles.portfolio}>
      <div className={styles.container}>
        <h3 className={styles["section-title"]}>Projects</h3>
        <h2 className={styles["section-text"]}>
          Each project is a unique piece of development
        </h2>
        <div className={styles.projects}>
          <Project
            code="https://github.com/bergjr/fitnessstudio"
            demo="https://fitnessstudio-three.vercel.app/"
            title="Fitness Studio"
            text="A gym website that is a comprehensive resource for fitness information, class schedules, membership options, and tools to help users achieve their fitness goals."
            img="fitnessstudio.jpg"
            tec="scss"
          />
          <Project
            code="https://github.com/bergjr/moodforfood"
            demo="https://moodforfood-nu.vercel.app/"
            title="Mood For Food"
            text="A restaurant website where you can view all food offerings and where you can order from."
            img="moodforfood.jpg"
            tec="scss"
            direction="inverted"
          />
          <Project
            demo="https://adoo.com.br"
            title="Adoo"
            text="Adoo is an online platform that helps anyone that wants to consult all the official
            documents published in the Official Gazette by the Brazilian government."
            img="adoo.jpg"
            tec="scss"
          />
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
